import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import {
  Container,
  Square,
  TMediaBreakPointSizes,
} from '@grubhubprod/gh-cookbook-react/dist';
import {
  useDeviceSize,
  Breakpoint,
} from '@grubhubprod/umami-library/dist/hooks/useDeviceSize';
import { getWindow } from 'src/utilities/window';
import { FIXED_SIGNUP_FOOTER_ID } from 'src/components/common/features/Signup/constants';

export interface ISignupStepFooterProps {
  children: ReactNode;
  containerSize?: TMediaBreakPointSizes;
}

export function SignupStepFooter({
  children,
  containerSize = 'sm',
}: ISignupStepFooterProps): JSX.Element {
  const window = getWindow();
  const signupFooterElement = window.document.getElementById(
    FIXED_SIGNUP_FOOTER_ID
  );
  const { breakpoint } = useDeviceSize(window);
  const isPhone = breakpoint < Breakpoint.sm;

  const footerContainer = (
    <Square inset={isPhone ? 'md' : 'lg'} dimension="2">
      <Container variant={containerSize}>{children}</Container>
    </Square>
  );

  if (signupFooterElement) {
    return createPortal(footerContainer, signupFooterElement);
  }

  return null;
}
